import styled, {css} from 'styled-components';


export const ContainerWrapper = styled.div<{noBackgroundColor: boolean, backgroundColor: string}>`
  display: flex;
  background-color: ${props=>getStyles('background-color', props.backgroundColor)};
  color: ${props=>getStyles('color', props.backgroundColor)};
  ${props => props.backgroundColor === 'campaign' && getStyles('backgroundImage', props.backgroundColor)};

  a:not([data-attribute='button']) {
    color:  ${props=>getStyles('color', props.backgroundColor)};
  }
`;

export const Container = styled.div<{colCount: number}>`
  width: 100%;

  @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.lg}){
    ${props => props.colCount <= 3 && css`
      display: flex;
    `}
  }

`;

export const HeadContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 48px 32px;

  @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.sm}){
    padding: 48px;
  }
`;

export const SubHeadContainer = styled.div<{colCount: number}>`
  @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.sm}){
    ${props => props.colCount === 4 && css`
      display: flex;
      justify-content: space-between;
      > * {
        flex:1
      }
    `}
  }
`;

export const Heading = styled.h3<{colCount: number, background: string}>`
  margin-top: 0;
  margin-bottom: 24px;
  text-transform: uppercase;
  font-size: 36px;
  font-weight: 400;
  line-height: 38px;
  ${props => getStyles('headingFont', props.background)};

  @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.sm}){
    ${props => props.colCount === 4 && css`
      margin-bottom: 0;
      padding-right: 48px;
    `}
  }
`;

export const Description = styled.div<{colCount: number}>`
  p {
    font-size: 20px;
    margin-bottom: 0;
  }
  @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.sm}){
    max-width: 600px;
    ${props => props.colCount === 4 && css`
      padding-left: 48px;
    `}
  }
  @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.lg}){
    max-width: none;
  }
`;

export const ButtonContainerTop = styled.div<{background: string, colCount: number, buttonType: string}>`
  display: none;
  a {
    ${props => getStyles(getPropertyNameForButtonType(props.buttonType), props.background)}}
  }

  @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.lg}){
    ${props => props.colCount < 4 && css`
      display: block;
    `}
  }
`;

export const ButtonContainerBottom = styled.div<{ background:string, colCount: number, buttonType: string}>`
  display: block;
  padding: 0 32px 48px 32px;
  
  a {
    width: 100%;
    ${props => getStyles(getPropertyNameForButtonType(props.buttonType), props.background)}}
  }

  @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.sm}){
    padding: 0 48px 48px 48px;
    a {
      width: auto;
    }
  } 

  @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.lg}){
    ${props => props.colCount < 4 && css`
      display: none;
    `}
  }
`;

export const ColContainer = styled.div<{colCount: number}>`
  display: flex;
  flex-direction: column;

  @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.sm}){
    flex-direction: row;
    ${props => props.colCount === 4 && css`
      flex-wrap: wrap;
    `}
  }

  @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.md}){
    ${props => props.colCount === 4 && css`
      flex-wrap: inherit;
    `}
  } 

  @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.lg}){
    ${props => props.colCount === 3 && css`
      flex: 3;
    `}
  }
`;

export const StyledColumn = styled.div<{ colCount: number, backgroundColor: string }>`
  flex: 1;
  padding 32px;

  a[data-attribute='button']{
    span {
      font-size: 16px;
      font-weight: 600;
    }
    &[type='arrow']{
      width: auto;
    }
  }

  ${props => props.backgroundColor !== 'default' && css`
    h2, h3, p, a[data-attribute='button']:not([type='primary']):not([type='secondary']) {
        ${getStyles('textColor', props.backgroundColor)}
      }
  `}

  ${props => props.backgroundColor === 'campaign' && css`
      h2 {
        font-family: DAMN;
        font-size: 46px;
        line-height: .82;
        font-weight: 400;
      }
    
      h3 {
        font-family: DAMN;
        font-size: 42px;
        line-height: .82;
        font-weight: 400;
      }

      div[data-attribute='imageContainer'] {
        padding-bottom: 100%;
      }
  `}


  @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.sm}){
    padding: 48px;
    ${props => props.colCount === 4 && css`
      flex-basis: 50%;
    `}
  }

  @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.md}){
    ${props => props.colCount === 4 && css`
      flex-basis: 0;
    `}
  }
 
  ${props => props.colCount === 1 && css`
    max-width: 824px;
  `}
`;

const getPropertyNameForButtonType = (buttonType: string) => {
  switch (buttonType) {
    case 'arrow':
      return 'arrowButton';
    default:
      return 'primaryButton';
  }
};

const getStyles = (property: string, theme: string) => {
  const styles = {
    default: {
      'color': '#161719',
      headingFont() {
        return css`
          font-family: Anton;
        `;
      },
      primaryButton() {
        return css`
          color: #FCFCFE;
        `;
      },
    },
    secondary: {
      'color': '#161719',
      'background-color':'#F0F0F0',
      headingFont() {
        return css`
          font-family: Anton;
        `;
      },
      primaryButton() {
        return css`
          color: #FCFCFE;
        `;
      },
      arrowButton() {
        return css`
          color: #0C0C0C;
        `;
      },
    },
    dark: {
      'color':'#FCFCFE',
      'background-color':'#161719',
      headingFont() {
        return css`
          font-family: Anton;
        `;
      },
      primaryButton() {
        return css`
          color: #161719;
          background-color: #FCFCFE;
        `;
      },
      textColor() {
        return css`
          color: #FCFCFE;
        `;
      }
    },
    campaign: {
      'color':'#FCFCFE',
      headingFont() {
        return css`
          font-family: DAMN;
          font-size: 45px;
          line-height: .82;
          @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.sm}){
            font-size: 56px;
          }
        `;
      },
      backgroundImage() {
        return css`
          background-image: url('/resources/images/global/campaign/background-mobile.jpg');
          background-size: auto 100vh;
          background-position: center;
          background-attachment: fixed;

          @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.sm}){
            background-image: url('/resources/images/global/campaign/background-tablet.jpg');
            background-size: cover;
          }

          @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.md}){
            background-image: url('/resources/images/global/campaign/background-desktop.jpg');
          }
        `;
      },
      primaryButton() {
        return css`
          color: #161719;
          background-color: #FCFCFE;
        `;
      },
      textColor() {
        return css`
          color: #FCFCFE;
        `;
      }      
    }
  };

  const selectedStyles = styles[theme as keyof typeof styles];

  return selectedStyles[property as keyof typeof selectedStyles] || '';
};
